<div [ngClass]="disabled() ? 'link-button disabled' : 'link-button'" (click)="onClick()">
    <div class="icon-layout">
        @if (iconClass()) {
            <i [class]="'link-icon ' + iconClass()"></i>
        }
        @else if (icon()) {
            <app-svg-icon [icon]="icon()"></app-svg-icon>
        }
        <ng-content></ng-content>
    </div>
</div>